/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { IntegrationShopify } from "./IntegrationShopify";
import {
  IntegrationShopifyFromJSON,
  IntegrationShopifyFromJSONTyped,
  IntegrationShopifyToJSON,
  IntegrationShopifyToJSONTyped,
} from "./IntegrationShopify";
import type { IntegrationBigCommerce } from "./IntegrationBigCommerce";
import {
  IntegrationBigCommerceFromJSON,
  IntegrationBigCommerceFromJSONTyped,
  IntegrationBigCommerceToJSON,
  IntegrationBigCommerceToJSONTyped,
} from "./IntegrationBigCommerce";
import type { IntegrationNetSuite } from "./IntegrationNetSuite";
import {
  IntegrationNetSuiteFromJSON,
  IntegrationNetSuiteFromJSONTyped,
  IntegrationNetSuiteToJSON,
  IntegrationNetSuiteToJSONTyped,
} from "./IntegrationNetSuite";
import type { UnreadableIntegration } from "./UnreadableIntegration";
import {
  UnreadableIntegrationFromJSON,
  UnreadableIntegrationFromJSONTyped,
  UnreadableIntegrationToJSON,
  UnreadableIntegrationToJSONTyped,
} from "./UnreadableIntegration";

/**
 *
 * @export
 * @interface CompanyIntegrations
 */
export interface CompanyIntegrations {
  /**
   *
   * @type {Array<IntegrationNetSuite>}
   * @memberof CompanyIntegrations
   */
  netsuite: Array<IntegrationNetSuite>;
  /**
   *
   * @type {Array<IntegrationShopify>}
   * @memberof CompanyIntegrations
   */
  shopify: Array<IntegrationShopify>;
  /**
   *
   * @type {Array<IntegrationBigCommerce>}
   * @memberof CompanyIntegrations
   */
  bigcommerce: Array<IntegrationBigCommerce>;
  /**
   *
   * @type {Array<UnreadableIntegration>}
   * @memberof CompanyIntegrations
   */
  unreadable: Array<UnreadableIntegration>;
}

/**
 * Check if a given object implements the CompanyIntegrations interface.
 */
export function instanceOfCompanyIntegrations(
  value: object,
): value is CompanyIntegrations {
  if (!("netsuite" in value) || value["netsuite"] === undefined) return false;
  if (!("shopify" in value) || value["shopify"] === undefined) return false;
  if (!("bigcommerce" in value) || value["bigcommerce"] === undefined)
    return false;
  if (!("unreadable" in value) || value["unreadable"] === undefined)
    return false;
  return true;
}

export function CompanyIntegrationsFromJSON(json: any): CompanyIntegrations {
  return CompanyIntegrationsFromJSONTyped(json, false);
}

export function CompanyIntegrationsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyIntegrations {
  if (json == null) {
    return json;
  }
  return {
    netsuite: (json["netsuite"] as Array<any>).map(IntegrationNetSuiteFromJSON),
    shopify: (json["shopify"] as Array<any>).map(IntegrationShopifyFromJSON),
    bigcommerce: (json["bigcommerce"] as Array<any>).map(
      IntegrationBigCommerceFromJSON,
    ),
    unreadable: (json["unreadable"] as Array<any>).map(
      UnreadableIntegrationFromJSON,
    ),
  };
}

export function CompanyIntegrationsToJSON(json: any): CompanyIntegrations {
  return CompanyIntegrationsToJSONTyped(json, false);
}

export function CompanyIntegrationsToJSONTyped(
  value?: CompanyIntegrations | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    netsuite: (value["netsuite"] as Array<any>).map(IntegrationNetSuiteToJSON),
    shopify: (value["shopify"] as Array<any>).map(IntegrationShopifyToJSON),
    bigcommerce: (value["bigcommerce"] as Array<any>).map(
      IntegrationBigCommerceToJSON,
    ),
    unreadable: (value["unreadable"] as Array<any>).map(
      UnreadableIntegrationToJSON,
    ),
  };
}
